<template>
    <f-dialog
        :title  = "entry.type.name"
        v-model = "value"
        :width  = "460"
        @cancel = "onCancel"
        @store  = "onSave"
    >
        <template v-slot:content>
            <crm-entry-edit
                :entry    = "entry"
                :incident = "incident"
                class     = "mb-1"
                ref       = "editor"
                @saved    = "onSaved"
            />
        </template>
    </f-dialog>
</template>

<script>
import FDialog from "@/modules/core/components/utils/FDialog";
import CrmEntryEdit from "@/modules/crm/components/main/CrmEntryEdit";
import Crm from "@/modules/crm/service/Crm.ts";
export default {
    name: "CrmEntryEditDialog",

    components: {
        CrmEntryEdit,
        FDialog
    },

    props: {
        value: {

        },

        incident: {

        },

        entry: {

        }
    },

    computed: {
        entryClass () {
            if (this.entry.deleted) {
                return 'crm-journal-deleted';
            }

            if (this.edit) {
                return 'crm-journal-edit';
            }

            return 'crm-journal-noedit';
        },

        isPhone () {
            return this.entry.type.id === Crm.journal.type.phone;
        },

        isReminder () {
            return this.entry.type.id === Crm.journal.type.reminder;
        },

        isPostponement () {
            return this.entry.type.id === Crm.journal.type.postponement;
        },
    },


    methods: {
        onCancel () {
            this.$emit("canceled");
            this.$emit("input", false);
        },

        onSave () {
            this.$refs.editor.onSave();
        },

        onSaved () {
            this.$emit("input", false);
            this.$emit("saved");
        }
    }
}
</script>

<style scoped>

</style>